const  seriesClassColor = {
    normal: ["#3574dc", "#b293ee"],
    pale: ["#86A6DC", "#F2D3FF"]
};
const  seriesHomeColor = {
    normal: ["#3574dc", "#b293ee", "#55bcfd", "#a1d852", "#ebd835"],
    pale: ["#86A6DC", "#F2D3FF", "#94E5FD", "#C1D7A0", "#C6BF80"]
};
const  seriesHomeColor2022 = {
    normal: ["#ffba00"],
    sum: ["#84cc3c"]
};
module.exports =  {
    seriesClassColor,
    seriesHomeColor,
    seriesHomeColor2022,
    seriesClassPlayChart: [
        { name: "교실영어", field: "playCountClass", stack: "base", option: { itemStyle: { color: seriesClassColor.normal[0] } } },
        { name: "스페셜", field: "playCountSpecial", stack: "base", option: { itemStyle: { color: seriesClassColor.normal[1] } } },
    ],
    seriesClassPlaySumChart: [
        { name: "교실영어", field: "playCountClassSum", stack: "base", option: { itemStyle: { color: seriesClassColor.normal[0] } } },
        { name: "스페셜", field: "playCountSpecialSum", stack: "base", option: { itemStyle: { color: seriesClassColor.normal[1] } } },
    ],
    seriesClassPlayChartAll: [
        { name: "교실영어(순)", field: "playCountClass", stack: "base", option: { itemStyle: { color: seriesClassColor.pale[0] } } },
        { name: "스페셜(순)", field: "playCountSpecial", stack: "base", option: { itemStyle: { color: seriesClassColor.pale[1] } } },
        { name: "교실영어(누적)", field: "playCountClassSum", stack: "base", option: { itemStyle: { color: seriesClassColor.normal[0] } } },
        { name: "스페셜(누적)", field: "playCountSpecialSum", stack: "base", option: { itemStyle: { color: seriesClassColor.normal[1] } } },
    ],
    seriesHomePlayChart: [
        { name: "교실영어", field: "playCountClass", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[0] } } },
        { name: "영상", field: "playCount3", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[1] } } },
        { name: "동화", field: "playCount4", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[2] } } },
        { name: "액티비티", field: "playCount5", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[3] } } },
        { name: "AI", field: "playCount6", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[4] } } },
    ],
    seriesHomePlayChart2022: [
        { name: "전체", field: "playCount", stack: "base", option: { itemStyle: { color: seriesHomeColor2022.normal[0] } } },
    ],
    seriesHomePlayChartChild: [
        { name: "전체", field: "playCount", stack: "base", option: { itemStyle: { color: "#4FCCD1" } } },
    ],
    seriesHomePlaySumChart: [
        { name: "교실영어", field: "playCountClassSum", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[0] } } },
        { name: "영상", field: "playCount3Sum", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[1] } } },
        { name: "동화", field: "playCount4Sum", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[2] } } },
        { name: "액티비티", field: "playCount5Sum", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[3] } } },
        { name: "AI", field: "playCount6Sum", stack: "base", option: { itemStyle: { color: seriesHomeColor.normal[4] } } },
    ],
    seriesHomePlaySumChart2022: [
        { name: "전체", field: "playCountSum", stack: "base", option: { itemStyle: { color: seriesHomeColor2022.sum[0] } } },
    ],
    seriesHomeLibraryChart: [
        { name: "영상", field: "playCount3", stack: "base3", option: { itemStyle: { color: seriesHomeColor.normal[1] } } },
        { name: "동화", field: "playCount4", stack: "base4", option: { itemStyle: { color: seriesHomeColor.normal[2] } } },
        { name: "액티비티", field: "playCount5", stack: "base5", option: { itemStyle: { color: seriesHomeColor.normal[3] } } },
        { name: "AI", field: "playCount6", stack: "base6", option: { itemStyle: { color: seriesHomeColor.normal[4] } } },
    ],
    seriesHomeAppConnectChart: [
        { name: "앱", field: "connectApp", stack: "base", showSum: true, option: { itemStyle: { color: "#60d7c5" } } },
        { name: "웹", field: "connectWeb", stack: "base", showSum: true, option: { itemStyle: { color: "#b9ed4a" } } },
    ],
    seriesHomeChildChart: [
        { name: "계약 원아 수", field: "contractChild", stack: "base", option: { itemStyle: { color: "#8ddfd4" } } },
        { name: "가입 원아 수", field: "childJoin", stack: "base1", option: { itemStyle: { color: "#d4c3f5" } } },
    ],
    seriesHomeParentChart: [
        { name: "계약 원아 수", field: "class_n_child", stack: "base", type: "bar", option: { itemStyle: { color: "#8ddfd4" } } },
        { name: "회원 가입 수", field: "parent_join", stack: "base1", type: "bar", option: { itemStyle: { color: "#d4c3f5" } } },
        // { name: "회원 탈퇴 수", field: "parent_deleted", stack: "base2" },
    ],
    seriesHomeTeacherChart: [
        { name: "계약 반 수", field: "class_n", stack: "base", type: "bar", option: { itemStyle: { color: "#8ddfd4" } } },
        { name: "회원 가입 수", field: "teacher_join", stack: "base1", type: "bar", option: { itemStyle: { color: "#d4c3f5" } } },
        // { name: "회원 탈퇴 수", field: "teacher_deleted", stack: "base2" },
    ]
};